import styled, { css } from "styled-components";
import { Link } from "react-router-dom";

export const StyledLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  min-height: 32px;
  min-width: 120px;
  height: fit-content;
  line-height: 0;
  transition: 0.5s ease;
  cursor: pointer;

  &:hover {
    opacity: 0.7;
  }

  ${({ $disabled }) =>
    $disabled &&
    css`
      pointer-events: none;
      cursor: default;

      &:hover {
        opacity: 1;
      }
    `}
`;
